import { render, staticRenderFns } from "./BehaviorModal.vue?vue&type=template&id=1a2f5290&scoped=true"
import script from "./BehaviorModal.vue?vue&type=script&lang=js"
export * from "./BehaviorModal.vue?vue&type=script&lang=js"
import style0 from "./BehaviorModal.vue?vue&type=style&index=0&id=1a2f5290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f5290",
  null
  
)

export default component.exports